import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputSwitch } from "primereact/inputswitch";
import { useTranslation } from "react-i18next";
import { EDITABLE_FIELDS } from "../../SystemSettings.config";
import "./Settings.styles.scss";

const Settings = ({ title, settings, edits, onFieldChange }) => {
  const { t } = useTranslation();

  // Pending edit for a field if there is one, otherwise whatever the server sent.
  const getField = (rowData, field) => {
    const edit = edits[rowData.key];
    if (edit && edit[field] !== undefined) {
      return edit[field];
    }
    return rowData[field] ?? "";
  };

  const isFieldChanged = (rowData, field) => {
    const edit = edits[rowData.key];
    return (
      !!edit &&
      edit[field] !== undefined &&
      edit[field] !== (rowData[field] ?? "")
    );
  };

  const isRowChanged = (rowData) =>
    EDITABLE_FIELDS.some((field) => isFieldChanged(rowData, field));

  const getNameRow = (rowData, field, rtl) => (
    <span className="setting_name" dir={rtl ? "rtl" : undefined}>
      {rowData[field] || "-"}
    </span>
  );

  const getValueRow = (rowData) => {
    const value = getField(rowData, "value");
    const isBoolean = rowData.value === "true" || rowData.value === "false";

    return (
      <div className="setting_value">
        {isBoolean ? (
          <label className="setting_switch">
            <InputSwitch
              checked={value === "true"}
              onChange={(e) =>
                onFieldChange(rowData.key, "value", e.value ? "true" : "false")
              }
            />
            <span className="setting_switch_label">
              {value === "true"
                ? t("system_settings.enabled")
                : t("system_settings.disabled")}
            </span>
          </label>
        ) : (
          <input
            className={
              isFieldChanged(rowData, "value")
                ? "setting_input changed"
                : "setting_input"
            }
            type="text"
            value={value}
            onChange={(e) => onFieldChange(rowData.key, "value", e.target.value)}
          />
        )}
        {isRowChanged(rowData) && (
          <span className="setting_changed_badge">
            {t("system_settings.unsaved")}
          </span>
        )}
      </div>
    );
  };

  return (
    <div className="settings_container">
      <h3 className="settings_category">{title}</h3>
      <DataTable value={settings} responsiveLayout="scroll" emptyMessage=" ">
        <Column
          header={t("system_settings.englishName")}
          body={(rowData) => getNameRow(rowData, "englishDescription", false)}
          field="englishDescription"
          sortable
        />
        <Column
          header={t("system_settings.arabicName")}
          body={(rowData) => getNameRow(rowData, "arabicDescription", true)}
          field="arabicDescription"
          sortable
        />
        <Column header={t("system_settings.value")} body={getValueRow} />

      </DataTable>
    </div>
  );
};

export default React.memo(Settings);
